import { useQuery } from '@tanstack/react-query';
import type {
  ConsultHistoryProps,
  consultHistoryService,
} from './ConsultHistoryService';
import { REFRESH_INTERVAL } from '../constants/CommanConstants';

type ConsultHistoryService = ReturnType<typeof consultHistoryService>;

export const createConsultHistoryHooks = (
  consultHistoryService: ConsultHistoryService
) => {
  const useConsultHistory = (consultId: number, portalType: string) => {
    const { data, isLoading, isError, error, refetch } =
      useQuery<ConsultHistoryProps>({
        queryKey: ['consultHistory', consultId],
        queryFn: async () => {
          const data = await consultHistoryService.getConsultHistory(
            consultId,
            portalType
          );
          return data;
        },

        staleTime: 0,
        gcTime: 0,
        refetchInterval: REFRESH_INTERVAL,
        enabled: !!consultId,
      });

    return {
      consultHistory: data,
      isLoading,
      isError,
      error,
      refetch,
    };
  };

  return {
    useConsultHistory,
  };
};
